import $ from 'jquery';
import { initGlobalSelect2 } from './select2-utils';

/**
 * Robust Form Population with Cascading Support
 * @param {jQuery} $form - The form element
 * @param {Object} data - The data object to populate
 */
export async function populateForm($form, data) {
    if (!$form || !data) return;

    const cascadeUpdates = [];
    const regularUpdates = [];

    Object.keys(data).forEach(key => {
        const $el = $form.find(`[name="${key}"], #${key}`);
        if ($el.length) {
            if ($el.is(':checkbox') || $el.is(':radio')) {
                $el.prop('checked', $el.val() == data[key]);
            } else if ($el.is('select')) {
                // If it's part of a cascade (parent OR child), handle it sequentially
                const isParent = $el.is('[data-cascade-child], [data-cascade-child-2], [data-cascade-child-3], [data-add-cascade-child], [data-add-cascade-child-2], [data-add-cascade-child-3]');
                const id = $el.attr('id');
                const isChild = id && $form.find(`[data-cascade-child="#${id}"], [data-cascade-child-2="#${id}"], [data-cascade-child-3="#${id}"], [data-add-cascade-child="#${id}"], [data-add-cascade-child-2="#${id}"], [data-add-cascade-child-3="#${id}"]`).length > 0;

                if (isParent || isChild) {
                    cascadeUpdates.push({ $el, val: data[key] });
                } else {
                    // Handle Multiple Select from comma-separated string
                    let val = data[key];
                    if ($el.prop('multiple') && typeof val === 'string' && val.includes(',')) {
                        val = val.split(',').map(s => s.trim());
                    }
                    regularUpdates.push({ $el, val: val });
                }
            } else if ($el.attr('type') !== 'file') {
                $el.val(data[key]);
            }
        }
    });

    // 1. Handle regular selects first
    regularUpdates.forEach(({ $el, val }) => {
        $el.val(val).trigger('change');
    });

    // 2. Handle cascading selects sequentially to allow child options to load
    if (cascadeUpdates.length > 0) {
        // Calculate depth for each element to sort strictly top-down
        cascadeUpdates.forEach(item => {
            let depth = 0;
            let currentId = item.$el.attr('id');
            let safeLimit = 10;
            while (currentId && safeLimit > 0) {
                const parentEl = $form.find(`[data-cascade-child="#${currentId}"], [data-cascade-child-2="#${currentId}"], [data-cascade-child-3="#${currentId}"], [data-add-cascade-child="#${currentId}"], [data-add-cascade-child-2="#${currentId}"], [data-add-cascade-child-3="#${currentId}"]`);
                if (parentEl.length) {
                    depth++;
                    currentId = parentEl.attr('id');
                    safeLimit--;
                } else {
                    break;
                }
            }
            item.depth = depth;
        });

        // Sort by depth ascending (0 = top level parent, 1 = child, 2 = grandchild)
        cascadeUpdates.sort((a, b) => a.depth - b.depth);

        for (const { $el, val } of cascadeUpdates) {
            const hasAjaxChild = $el.is('[data-cascade-url], [data-cascade-url-2], [data-cascade-url-3], [data-add-cascade-url], [data-add-cascade-url-2], [data-add-cascade-url-3]');
            
            if (hasAjaxChild) {
                // Set value and trigger change
                $el.val(val).trigger('change');

                // Wait a tiny bit for the cascading-select async handler to start AJAX
                await new Promise(r => setTimeout(r, 100));

                // Wait for the cascading child to finish loading options via AjaxList.fetch
                const childSelectors = ['data-cascade-child', 'data-cascade-child-2', 'data-cascade-child-3', 'data-add-cascade-child', 'data-add-cascade-child-2', 'data-add-cascade-child-3'];
                let childSelector = null;
                for (let attr of childSelectors) {
                    if ($el.attr(attr)) {
                        childSelector = $el.attr(attr);
                        break;
                    }
                }

                if (childSelector) {
                    const $child = $form.find(childSelector);
                    if ($child.length) {
                        console.log(`[FormUtils] Waiting for cascadingComplete from ${$child.attr('id')}...`);
                        await new Promise(resolve => {
                            $child.one('cascadingComplete', resolve);
                            setTimeout(resolve, 3000); // Safety timeout
                        });
                    }
                }
            } else {
                $el.val(val).trigger('change');
                // Small delay to let Select2/DOM settle
                await new Promise(r => setTimeout(r, 50));
            }
        }
    }
}
